<template>
  <section class="home-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <div class="container">
        <div class="hero-inner">
          <span class="hero-badge" data-aos="fade-down" data-aos-duration="800">
            <i class="ri-leaf-line"></i> 100% Zabiha Halal
          </span>
          <h1 data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
            Authentic Mexican.<br />
            <span class="text-accent">Purely Halal.</span>
          </h1>
          <p class="hero-subtitle" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400">
            Fresh bowls, tacos & quesadillas crafted with Zabiha halal meats 
            and antibiotic-free produce — served fast-casual style.
          </p>
          <div class="hero-actions" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="600">
            <a 
              href="#investment"
              class="btn-primary-hero"
              @click.prevent="scrollToInvestment"
            >
              <i class="ri-funds-line"></i> Franchise Investment
            </a>
            <a href="#menu" class="btn-secondary-hero" @click.prevent="scrollToMenu">
              <i class="ri-restaurant-line"></i> View Menu
            </a>
          </div>
          <div class="hero-badges" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="800">
            <div class="badge-item">
              <i class="ri-star-fill"></i>
              <span>4.9 on Google</span>
            </div>
            <div class="badge-divider"></div>
            <div class="badge-item">
              <i class="ri-map-pin-2-fill"></i>
              <span>1244 Stors Rd, Storrs Mansfield</span>
            </div>
            <div class="badge-divider"></div>
            <div class="badge-item">
              <i class="ri-time-line"></i>
              <span>Open Daily</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-scroll-indicator" data-aos="fade-up" data-aos-delay="1200">
      <span>Scroll</span>
      <div class="scroll-line"></div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeHero",
  setup() {
    const scrollToMenu = () => {
      const el = document.getElementById('menu');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    const scrollToInvestment = () => {
      const el = document.getElementById('investment');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    return { scrollToMenu, scrollToInvestment };
  },
});
</script>

<style lang="scss" scoped>
.home-hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('https://images.unsplash.com/photo-1565299585323-38d6b0865b47?auto=format&fit=crop&w=1920&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  overflow: hidden;

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(10, 10, 10, 0.7) 0%,
      rgba(10, 10, 10, 0.5) 40%,
      rgba(10, 10, 10, 0.8) 100%
    );
    z-index: 1;
  }

  .hero-content {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 140px 0 100px;
  }

  .hero-inner {
    max-width: 720px;
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(181, 255, 0, 0.15);
    border: 1px solid rgba(181, 255, 0, 0.3);
    color: #b5ff00;
    padding: 8px 20px;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 28px;
    i {
      font-size: 16px;
    }
  }

  h1 {
    font-size: 72px;
    font-weight: 800;
    color: #ffffff;
    line-height: 1.08;
    letter-spacing: -2px;
    margin-bottom: 24px;
    .text-accent {
      color: #b5ff00;
    }
  }

  .hero-subtitle {
    font-size: 19px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.7;
    margin-bottom: 40px;
    max-width: 560px;
  }

  .hero-actions {
    display: flex;
    gap: 16px;
    margin-bottom: 48px;

    .btn-primary-hero {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: #b5ff00;
      color: #0a0a0a;
      padding: 16px 36px;
      border-radius: 60px;
      font-size: 16px;
      font-weight: 700;
      text-decoration: none;
      transition: all 0.3s ease;
      border: 2px solid #b5ff00;
      &:hover {
        background: transparent;
        color: #b5ff00;
        transform: translateY(-2px);
        box-shadow: 0 8px 30px rgba(181, 255, 0, 0.25);
      }
    }

    .btn-secondary-hero {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: transparent;
      color: #ffffff;
      padding: 16px 36px;
      border-radius: 60px;
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.3s ease;
      border: 2px solid rgba(255, 255, 255, 0.3);
      &:hover {
        border-color: #ffffff;
        transform: translateY(-2px);
        box-shadow: 0 8px 30px rgba(255, 255, 255, 0.1);
      }
    }
  }

  .hero-badges {
    display: flex;
    align-items: center;
    gap: 20px;

    .badge-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
      font-weight: 500;
      i {
        color: #b5ff00;
        font-size: 16px;
      }
    }

    .badge-divider {
      width: 1px;
      height: 20px;
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .hero-scroll-indicator {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    span {
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: rgba(255, 255, 255, 0.4);
    }
    .scroll-line {
      width: 1px;
      height: 40px;
      background: linear-gradient(to bottom, rgba(181, 255, 0, 0.6), transparent);
      animation: scrollPulse 2s ease-in-out infinite;
    }
  }
}

@keyframes scrollPulse {
  0%, 100% { opacity: 0.4; transform: scaleY(0.8); }
  50% { opacity: 1; transform: scaleY(1); }
}

@media (max-width: 991px) {
  .home-hero {
    background-attachment: scroll;
    h1 {
      font-size: 48px;
      letter-spacing: -1px;
    }
    .hero-subtitle {
      font-size: 16px;
    }
    .hero-actions {
      flex-direction: column;
      .btn-primary-hero,
      .btn-secondary-hero {
        justify-content: center;
        padding: 14px 28px;
        font-size: 15px;
      }
    }
    .hero-badges {
      flex-wrap: wrap;
      gap: 12px;
    }
  }
}

@media (max-width: 575px) {
  .home-hero {
    h1 {
      font-size: 36px;
    }
    .hero-content {
      padding: 120px 0 80px;
    }
  }
}
</style>
